import { useState, useEffect } from 'react';
import axios from 'axios';

const EU_COUNTRIES = [
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE',
  'GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT',
  'RO','SK','SI','ES','SE'
];

const CACHE_KEY = 'geo:isEU';
// 200 hours in ms
const CACHE_TTL = 200 * 60 * 60 * 1000;

export function useIsEU() {
  const [isEU, setIsEU] = useState<boolean | null>(null);

  useEffect(() => {
    // 1) Try cache
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        const { timestamp, value } = JSON.parse(raw);
        if (Date.now() - timestamp < CACHE_TTL) {
          setIsEU(value);
          return;
        }
      }
    } catch {
      // ignore
    }

    // 2) Geo-lookup
    (async () => {
      try {
        const key = "d5a756a764e248854368e06ff31e506948471e7c40bffa73c0dde8c8";
        const url = `https://api.ipdata.co?api-key=${key}&fields=country_code`;
        const resp = await axios.get(url);
        const country = resp.data.country_code as string|undefined;
        const inEU = country != null && EU_COUNTRIES.includes(country);
        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({ value: inEU, timestamp: Date.now() })
        );
        setIsEU(inEU);
      } catch {
        setIsEU(false);
      }
    })();
  }, []);

  return isEU;
}
